import React from 'react';
import { useParams } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { H3 } from 'shared-assets/components/Elements';
import Button from 'shared-assets/components/Elements/Button';
import TelehealthLogo from 'shared-assets/talking-parrot-ui/components/TelehealthLogo';
import LayoutCentered from './LayoutCentered';
var EndSession = function (_a) {
    var history = _a.history;
    var uniqueIdForUrl = useParams().uniqueIdForUrl;
    return (React.createElement(LayoutCentered, null,
        React.createElement(TelehealthLogo, null),
        React.createElement(Card, { style: { width: '100%' } },
            React.createElement(CardContent, null,
                React.createElement(H3, null, "Your visit is now complete"),
                React.createElement("p", null, "You can now close this window."),
                React.createElement("p", null,
                    "If you left by mistake, you can ",
                    ' ' /**  @ts-ignore */,
                    React.createElement(Button, { type: "button", className: "link noBtn", track: {
                            data: {
                                name: 'Rejoin Telehealth',
                                uniqueIdForUrl: uniqueIdForUrl,
                            },
                        }, onClick: function () {
                            history.goBack();
                        } }, "rejoin this session"),
                    ".")))));
};
export default EndSession;
